export const primaryColor = '#00ca9a'; 